"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbFileInput = exports._SbFileInput = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _shapes = require("../../skybase-core/shapes");

var _value = require("../../skybase-core/utils/value");

var _utils = require("./utils");

var _sbFileInputI18n = require("./sb-file-input-i18n");

var _propTypeMessage = require("../../skybase-core/shapes/prop-type-message");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NOOP = function NOOP() {}; // eslint-disable-next-line no-underscore-dangle, react/prefer-stateless-function


var _SbFileInput = /*#__PURE__*/function (_Component) {
  _inherits(_SbFileInput, _Component);

  var _super = _createSuper(_SbFileInput);

  function _SbFileInput(props) {
    var _this;

    _classCallCheck(this, _SbFileInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChange", function (evt) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onReceiveFiles = _this$props.onReceiveFiles;
      onChange(evt);
      onReceiveFiles(evt.target.files || []);

      _this.setFileNameToState(evt.target.files);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragEnter", function (evt) {
      evt.preventDefault();
      var disabled = _this.props.disabled;

      if (!disabled) {
        _this.setState({
          lastTarget: evt.target
        });

        _this.setState({
          showOverlay: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDragOver", function (evt) {
      evt.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_this), "onDragLeave", function (evt) {
      evt.preventDefault();
      var disabled = _this.props.disabled;
      var lastTarget = _this.state.lastTarget;

      if (!disabled && evt.target === lastTarget) {
        _this.setState({
          showOverlay: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDrop", function (evt) {
      evt.preventDefault();
      var _this$props2 = _this.props,
          accept = _this$props2.accept,
          disabled = _this$props2.disabled,
          onChange = _this$props2.onChange,
          onReceiveFiles = _this$props2.onReceiveFiles;

      if (!disabled) {
        var typesAreValid = true; // check if files are the valid type

        if (accept) {
          var _files = evt.dataTransfer ? evt.dataTransfer.files : evt.target.files;

          Object.keys(_files).forEach(function (key) {
            if (!_files[key].name.endsWith(accept)) {
              typesAreValid = false;
            }
          });
        }

        if (onChange && typesAreValid) {
          onChange(evt);
        }

        var files = evt.dataTransfer ? evt.dataTransfer.files || [] : [];

        _this.setFileNameToState(files);

        if (onReceiveFiles && typesAreValid) {
          onReceiveFiles(files);
        }

        _this.setState({
          showOverlay: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnFocus", function (event) {
      var onFocus = _this.props.onFocus;

      _this.setState({
        focused: true
      });

      if (onFocus) {
        onFocus(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnBlur", function (event) {
      var onBlur = _this.props.onBlur;

      _this.setState({
        focused: false
      });

      if (onBlur) {
        onBlur(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setFileNameToState", function (files) {
      var file = files[0] || {};
      var name = file.name;

      if (files.length > 1) {
        name = Array.from(files).map(function (_ref) {
          var fileName = _ref.name;
          return fileName;
        }).join(', ');
      }

      var fileSize = Math.round((0, _utils.getFilesSize)(files) / 1024);

      if (name) {
        _this.setState({
          fileName: name,
          fileSize: fileSize
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderFileSizeLabel", function () {
      var fileSize = _this.state.fileSize;
      var _ = _this.props.intl.formatMessage;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-file-input-file-size-label"
      }, "".concat(_(_sbFileInputI18n.messages.fileSize), ": ").concat(fileSize, " kB"));
    });

    _this.state = {
      focused: false,
      fileName: props.fileName,
      showOverlay: false,
      fileSize: 0
    };
    return _this;
  }

  _createClass(_SbFileInput, [{
    key: "renderFileInput",
    value: function renderFileInput() {
      var _this$props3 = this.props,
          title = _this$props3.title,
          className = _this$props3.className,
          containerClassName = _this$props3.containerClassName,
          containerId = _this$props3.containerId,
          id = _this$props3.id,
          disabled = _this$props3.disabled,
          fileNameProp = _this$props3.fileName,
          fileNameVisible = _this$props3.fileNameVisible,
          fileSizeVisible = _this$props3.fileSizeVisible,
          buttonClassName = _this$props3.buttonClassName,
          isDroppable = _this$props3.isDroppable,
          onChange = _this$props3.onChange,
          onReceiveFiles = _this$props3.onReceiveFiles,
          inputRef = _this$props3.inputRef,
          _ = _this$props3.intl.formatMessage,
          style = _this$props3.style,
          hasError = _this$props3.hasError,
          rest = _objectWithoutProperties(_this$props3, ["title", "className", "containerClassName", "containerId", "id", "disabled", "fileName", "fileNameVisible", "fileSizeVisible", "buttonClassName", "isDroppable", "onChange", "onReceiveFiles", "inputRef", "intl", "style", "hasError"]);

      var _this$state = this.state,
          focused = _this$state.focused,
          fileName = _this$state.fileName,
          fileSize = _this$state.fileSize,
          showOverlay = _this$state.showOverlay;
      var buttonClassNames = (0, _classnames.default)('sb-btn', 'sb-browse-button', buttonClassName, {
        disabled: disabled,
        'has-error': hasError,
        focus: focused
      });
      var containerClassNames = (0, _classnames.default)('sb-file-input', {
        'sb-file-input-droppable': isDroppable,
        disabled: disabled,
        'has-error': hasError
      }, containerClassName);
      var fileNameClassNames = (0, _classnames.default)('sb-textbox', 'sb-filename', {
        disabled: disabled,
        'has-error': hasError,
        focus: focused
      });

      var noFileChosen = _(_sbFileInputI18n.messages.noFileChosen);

      var browse = title || _(_sbFileInputI18n.messages.browse);

      return /*#__PURE__*/_react.default.createElement("div", {
        className: containerClassNames,
        id: containerId,
        style: style
      }, showOverlay && /*#__PURE__*/_react.default.createElement("div", {
        className: "dropzone"
      }, /*#__PURE__*/_react.default.createElement("span", null, _(_sbFileInputI18n.messages.dropFilesHereToUpload))), /*#__PURE__*/_react.default.createElement("div", {
        className: "input-area"
      }, /*#__PURE__*/_react.default.createElement("input", _extends({}, rest, {
        id: id,
        className: (0, _classnames.default)('sb-file-input', className),
        type: "file",
        onChange: this.onChange,
        onFocus: this.handleOnFocus,
        onBlur: this.handleOnBlur,
        disabled: disabled,
        ref: inputRef
      })), fileNameVisible && /*#__PURE__*/_react.default.createElement("label", {
        className: fileNameClassNames,
        htmlFor: id
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ellipsis-font"
      }, fileName || noFileChosen)), /*#__PURE__*/_react.default.createElement("label", {
        className: buttonClassNames,
        htmlFor: id
      }, browse)), fileSizeVisible && !isNaN(fileSize) && this.renderFileSizeLabel());
    }
  }, {
    key: "renderFileInputDroppable",
    value: function renderFileInputDroppable() {
      return /*#__PURE__*/_react.default.createElement("div", {
        onDragEnter: this.onDragEnter,
        onDragLeave: this.onDragLeave,
        onDragOver: this.onDragOver,
        onDrop: this.onDrop
      }, this.renderFileInput());
    }
  }, {
    key: "render",
    value: function render() {
      var isDroppable = this.props.isDroppable;
      return !isDroppable ? this.renderFileInput() : this.renderFileInputDroppable();
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, currentState) {
      var nextFileName = nextProps.fileName;
      var fileName = currentState.fileName;

      if (!(0, _value.isNullOrUndefined)(nextFileName) && fileName !== nextFileName) {
        return {
          fileName: nextFileName
        };
      }

      return null;
    }
  }]);

  return _SbFileInput;
}(_react.Component);

exports._SbFileInput = _SbFileInput;

_defineProperty(_SbFileInput, "propTypes", {
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypeMessage.PropTypeMessage, _shapes.intlShape]),
  className: _propTypes.default.string,
  containerClassName: _propTypes.default.string,
  containerId: _propTypes.default.string,
  id: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool,
  fileName: _propTypes.default.string,
  fileNameVisible: _propTypes.default.bool,
  fileSizeVisible: _propTypes.default.bool,
  intl: _shapes.intlShape.isRequired,
  buttonClassName: _propTypes.default.string,
  isDroppable: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onReceiveFiles: _propTypes.default.func,
  inputRef: _shapes.PropTypeRef,
  style: _propTypes.default.object,
  // eslint-disable-line
  hasError: _propTypes.default.bool,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func
});

_defineProperty(_SbFileInput, "defaultProps", {
  title: null,
  className: null,
  containerClassName: null,
  containerId: null,
  disabled: false,
  fileName: null,
  fileNameVisible: true,
  fileSizeVisible: false,
  buttonClassName: null,
  isDroppable: false,
  onChange: NOOP,
  onReceiveFiles: NOOP,
  inputRef: NOOP,
  style: null,
  hasError: false,
  onFocus: null,
  onBlur: null
});

var SbFileInput = (0, _reactIntl.injectIntl)(_SbFileInput);
exports.SbFileInput = SbFileInput;
//# sourceMappingURL=sb-file-input.js.map